module.exports = __webpack_public_path__ + "img/4.1ac589e4.png";